<form novalidate [formGroup]="ldapServerForm" *ngIf="!wizardCtrl.getWizardService().isLoading" #currentForm="ngForm">
    <div class="bottom-margin">Connection details</div>
    <div class="host-protocol-parent">
        <div class="group parent-input-width host-protocol">
            <select class="form-select protocol" name="protocol">
                <option value="ldap" selected="selected">ldap://</option>
                <option value="ldaps">ldaps://</option>
            </select>
            <input autocomplete="off" matInput class="hostname input-width width-90"
                placeholder="ldap.mycompany.com:389,fallback.mycompany.com:389" name="servers" [(ngModel)]="servers"
                (ngModelChange)="serversUpdated()" formControlName="servers" required />
        </div>
        <div class="error bottom-margin" *ngIf="serversInput.invalid && (serversInput.dirty || serversInput.touched)">
            <mat-error *ngIf="ldapServerForm.hasError('required', 'servers')">Servers is required</mat-error>
            <mat-error *ngIf="ldapServerForm.hasError('matchPattern', 'servers')">Servers is invalid</mat-error>
        </div>
    </div>
    <div class="settings-from">
        <div class="auth-settings">
            <div>Authorization</div>
            <div class="margin-top1rem">
                <mat-checkbox class="ananymous-checkbox" color="primary" [checked]="anonymousBind"
                    [(ngModel)]="anonymousBind" formControlName="anonymousBind" name="anonymousBind"
                    (change)="anonymousBindUpdated()">
                    Anonymous bind
                </mat-checkbox>
            </div>
            <div class="group parent-input-width margin-top1rem">
                <p class=" label">Bind DN</p>
                <input autocomplete="off" matInput class="input-width width-95" name="bindDN" [(ngModel)]="bindDN"
                    formControlName="bindDN" anonymousBind (ngModelChange)="bindDNUpdated()" />
            </div>
            <div class=" group parent-input-width margin-top1rem">
                <p class=" label">Bind Password</p>
                <div class="password">
                    <div class="width-100">
                        <input autocomplete="off" matInput class="input-width width-95" name="bindPassword"
                            [type]="hide ? 'password' : 'text'" [(ngModel)]="bindPassword"
                            formControlName="bindPassword" (change)="bindPasswordUpdated()" />
                    </div>
                    <div class="visiblity-icon">
                        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </div>
                </div>
            </div>
            <mat-checkbox class="ananymous-checkbox" color="primary" [checked]="trustSSLCertificate"
                [(ngModel)]="trustSSLCertificate" formControlName="trustSSLCertificate" name="trustSSLCertificate"
                (change)="trustSSLCertificateUpdated()">
                Trust any SSL Certificate
            </mat-checkbox>
            <div class="group parent-input-width margin-top1rem">
                <p class="label">Trust certificate (PEM Encoded cert)</p>
                <textarea class="form-control certificate" name="trustCertificate" [(ngModel)]="trustCertificate"
                    formControlName="trustCertificate" (ngModelChange)="trustCertificateUpdated()"
                    placeholder="--- BEGIN CERTIFICATE ---"></textarea>
            </div>
        </div>
        <div class="width-35">
            <div class="connection-settings">
                <div>Connection settings</div>
                <div class=" group parent-input-width margin-top1rem">
                    <p class="label">Base DN *</p>
                    <input autocomplete="off" matInput class="input-width width-95" name="baseDN" [(ngModel)]="baseDN"
                        placeholder="cn=xor22h,ou=users,ou=nci,dc=viavi,dc=com" formControlName="baseDN" required
                        (ngModelChange)="baseDNUpdated()" />
                    <div class="error" *ngIf="baseDNInput.invalid && (baseDNInput.dirty || baseDNInput.touched)">
                        <mat-error *ngIf="ldapServerForm.hasError('required', 'baseDN')">Base DN is required
                        </mat-error>
                    </div>
                </div>
                <div class="group parent-input-width">
                    <p class="label">Users filter *</p>
                    <input autocomplete="off" matInput class="input-width width-95" name="usersFilter"
                        placeholder="(objectClass=posixAccount)" [(ngModel)]="usersFilter" formControlName="usersFilter"
                        required (ngModelChange)="usersFilterUpdated()" />
                    <div class="error"
                        *ngIf="usersFilterInput.invalid && (usersFilterInput.dirty || usersFilterInput.touched)">
                        <mat-error *ngIf="ldapServerForm.hasError('required', 'usersFilter')">Users filter is required
                        </mat-error>
                    </div>
                </div>
            </div>
            <div class="connection-settings">
                <div>Group settings (optional)</div>
                <div class=" group parent-input-width margin-top1rem">
                    <p class="label">Group Base DN</p>
                    <input autocomplete="off" matInput class="input-width width-95" name="groupBaseDN"
                        placeholder="cn=xor22h,ou=users,ou=nci,dc=viavi,dc=com" [(ngModel)]="groupBaseDN"
                        formControlName="groupBaseDN" (ngModelChange)="groupBaseDNUpdated()" />
                </div>
                <div class="group parent-input-width">
                    <p class="label">Groups filter</p>

                    <input autocomplete="off" matInput class="input-width width-95" name="groupsFilter"
                        placeholder="(objectClass=groupOfUniqueNames)" [(ngModel)]="groupsFilter"
                        formControlName="groupsFilter" (ngModelChange)="groupsFilterUpdated()" />
                </div>
                <div class="group parent-input-width width-99">
                    <p class="label">Group Membership Attribute</p>
                    <div>
                        <input autocomplete="off" matInput class="hostname input-width group-membership"
                            name="groupMembershipAttribute" placeholder="uniqueMember"
                            [(ngModel)]="groupMembershipAttribute" formControlName="groupMembershipAttribute"
                            (ngModelChange)="groupMembershipAttributeUpdated()" />
                        <select class="form-select protocol width-30" name="groupFilterBy" [(ngModel)]="groupFilterBy"
                            (ngModelChange)="groupFilterByUpdated()" formControlName="groupFilterBy">
                            <option value="dn">Entry DN</option>
                            <option value="username">Username</option>
                            <option value="email">Email</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="ldap-properties">
            <div>LDAP Properties</div>
            <div class="group parent-input-width margin-top1rem">
                <p class="label">Username attribute *</p>
                <input autocomplete="off" matInput class="input-width width-95" name="usernameAttribute"
                    placeholder="cn" [(ngModel)]="usernameAttribute" formControlName="usernameAttribute" required
                    (ngModelChange)="usernameAttributeUpdated()" />
                <div class="error"
                    *ngIf="usernameAttributeInput.invalid && (usernameAttributeInput.dirty || usernameAttributeInput.touched)">
                    <mat-error *ngIf="ldapServerForm.hasError('required', 'usernameAttribute')">
                        Username attribute is required
                    </mat-error>
                </div>
            </div>
            <div class=" group parent-input-width">
                <p class="label">Name Attribute *</p>
                <input autocomplete="off" matInput class="input-width width-95" name="nameAttribute"
                    placeholder="givenName" [(ngModel)]="nameAttribute" formControlName="nameAttribute" required
                    (ngModelChange)="nameAttributeUpdated()" />
                <div class="error"
                    *ngIf="nameAttributeInput.invalid && (nameAttributeInput.dirty || nameAttributeInput.touched)">
                    <mat-error *ngIf="ldapServerForm.hasError('required', 'nameAttribute')">Name attribute is
                        required</mat-error>
                </div>
            </div>
            <div class="group parent-input-width">
                <p class="label">Surname Attribute *</p>
                <input autocomplete="off" matInput class="input-width width-95" name="surnameAttribute" placeholder="sn"
                    [(ngModel)]="surnameAttribute" formControlName="surnameAttribute" required
                    (ngModelChange)="surnameAttributeUpdated()" />
                <div class="error"
                    *ngIf="surnameAttributeInput.invalid && (surnameAttributeInput.dirty || surnameAttributeInput.touched)">
                    <mat-error *ngIf="ldapServerForm.hasError('required', 'nameAttribute')">
                        Surname attribute is required
                    </mat-error>
                </div>
            </div>
            <div class="group parent-input-width">
                <p class="label">Email Attribute *</p>
                <input autocomplete="off" matInput class="input-width width-95" name="emailAttribute" placeholder="mail"
                    [(ngModel)]="emailAttribute" formControlName="emailAttribute" required
                    (ngModelChange)="emailAttributeUpdated()" />
                <div class="error"
                    *ngIf="emailAttributeInput.invalid && (emailAttributeInput.dirty || emailAttributeInput.touched)">
                    <mat-error *ngIf="ldapServerForm.hasError('required', 'emailAttribute')">Email attribute is required
                    </mat-error>
                </div>
            </div>
            <div class="group parent-input-width">
                <p class="label">Membership Attribute *</p>
                <input autocomplete="off" matInput class="input-width width-95" name="membershipAttribute"
                    placeholder="memberOf" [(ngModel)]="membershipAttribute" formControlName="membershipAttribute"
                    required (ngModelChange)="membershipAttributeUpdated()" />
                <div class="error"
                    *ngIf="membershipAttributeInput.invalid && (membershipAttributeInput.dirty || membershipAttributeInput.touched)">
                    <mat-error *ngIf="ldapServerForm.hasError('required', 'membershipAttribute')">
                        Membership Attribute is required
                    </mat-error>
                </div>
            </div>
            <div class="group parent-input-width">
                <p class="label">Group Name attribute *</p>
                <input autocomplete="off" matInput class="input-width width-95" name="groupNameAttribute"
                    placeholder="cn" [(ngModel)]="groupNameAttribute" formControlName="groupNameAttribute" required
                    (ngModelChange)="groupNameAttributeUpdated()" />
                <div class="error"
                    *ngIf="groupNameAttributeInput.invalid && (groupNameAttributeInput.dirty || groupNameAttributeInput.touched)">
                    <mat-error *ngIf="ldapServerForm.hasError('required', 'groupNameAttribute')">
                        Group name attribute is required
                    </mat-error>
                </div>
            </div>
        </div>
    </div>
</form>

<div *ngIf="wizardCtrl.getWizardService().isLoading" class="loader">
    <div class="loader-msg-header">
        <p>{{ loadMessage }}</p>
    </div>
    <div class="align-center">
        <mat-spinner></mat-spinner>
    </div>
    <p class="loader-msg align-center">One moment...</p>
</div>